import { render, staticRenderFns } from "./ReplicationTable.vue?vue&type=template&id=e1e85ca8&scoped=true&"
import script from "./ReplicationTable.vue?vue&type=script&lang=js&"
export * from "./ReplicationTable.vue?vue&type=script&lang=js&"
import style0 from "./ReplicationTable.vue?vue&type=style&index=0&id=e1e85ca8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e85ca8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1e85ca8')) {
      api.createRecord('e1e85ca8', component.options)
    } else {
      api.reload('e1e85ca8', component.options)
    }
    module.hot.accept("./ReplicationTable.vue?vue&type=template&id=e1e85ca8&scoped=true&", function () {
      api.rerender('e1e85ca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/ReplicationTable.vue"
export default component.exports